// Заготовки для раздела «Рассылка» (замечание владельца 2026-09-20: «нужны
// готовые SMS-уведомления для рассылки юзерам, для разных ситуаций»).
//
// Это КОНТЕНТ, а не данные, поэтому живёт на фронте рядом с translations.js:
// правится вместе с кодом, не требует ни бэкенда, ни сети, ни миграций.
//
// Формат заготовки:
//   id        — стабильный ключ (по нему ничего не хранится, но менять не надо);
//   group     — заголовок группы в UI (по нему заготовки и раскладываются);
//   title     — подпись кнопки;
//   hint      — когда это отправлять (мелкая строка под кнопками);
//   segment   — рекомендованный сегмент получателей (подставится в чипсы,
//               админ может сменить — здесь именно рекомендация);
//   parseMode — 'HTML' там, где в тексте есть выделение или ссылка, иначе null
//               (обычный текст). HTML-теги в тексте БЕЗ parseMode='HTML'
//               отправились бы юзеру как есть, поэтому они всегда в паре;
//   when      — что должно быть выполнено перед отправкой (показывается админу);
//   ru, en    — готовые тексты на двух языках.
//
// Почему оба языка написаны вручную: для готовых сценариев качество перевода
// важно, а машинный перевод (см. TG-BOT/src/translate.js) включается только для
// текста, который админ набрал сам. Если en у заготовки непустой — он и уйдёт
// англоязычным, автоперевод для этой рассылки не понадобится.
//
// Тон и факты: тексты не обещают сроков, не обещают сохранности того, за что
// код не отвечает, и всегда дают юзеру одно простое действие + выход в поддержку
// (@fund1ngsupport, см. constants/support.js). Формулировки про интерфейс —
// по факту: у бота на карточке ПОЛЗУНОК (вкл/выкл), отдельных кнопок
// «Запустить»/«Остановить» в приложении нет.

export const BROADCAST_TEMPLATE_GROUPS = ['Сбои и работы', 'Нововведения', 'Проверка после работ']

export const BROADCAST_TEMPLATES = [
  // ───────────────────────── Сбои и работы ─────────────────────────
  {
    id: 'restart-check',
    group: 'Сбои и работы',
    title: 'Перезапустил приложение — проверьте ботов',
    hint: 'После вашего перезапуска сервера: у кого-то бот мог не встать обратно в работу.',
    segment: 'withbots',
    parseMode: null,
    when: 'Отправлять сразу после перезапуска, пока юзеры ещё не заметили проблему сами.',
    ru:
      '🔄 Я перезапускал приложение\n\n' +
      'Если у вас уже запущены боты — проверьте, пожалуйста, что они продолжают торговать.\n\n' +
      'Как проверить:\n' +
      '1. Откройте раздел «Боты».\n' +
      '2. Посмотрите на ползунок в карточке бота — он должен быть включён (зелёный).\n' +
      '3. Если ползунок выключен — включите его.\n' +
      '4. Если бот включён, но стоит без движения — выключите и включите его снова.\n\n' +
      'Если бот всё равно не запускается — напишите в поддержку: @fund1ngsupport',
    en:
      '🔄 I restarted the app\n\n' +
      'If you already have bots running, please check that they are still trading.\n\n' +
      'How to check:\n' +
      '1. Open the "Bots" section.\n' +
      '2. Look at the switch on the bot card — it should be on (green).\n' +
      '3. If the switch is off, turn it on.\n' +
      '4. If the bot is on but not trading, turn it off and on again.\n\n' +
      'If the bot still does not start, contact support: @fund1ngsupport',
  },
  {
    id: 'downtime-apology',
    group: 'Сбои и работы',
    title: 'Извинения за временную недоступность',
    hint: 'Когда приложение/боты были недоступны из-за работ — с извинениями и просьбой проверить.',
    segment: 'all',
    parseMode: null,
    when: 'Отправлять, когда работы уже закончились и всё восстановлено.',
    ru:
      '🙏 Приносим извинения за временную недоступность\n\n' +
      'Во время технических работ приложение могло работать с перебоями: какие-то разделы временно не открывались, а боты могли не отвечать на команды.\n\n' +
      'Сейчас всё восстановлено. Пожалуйста, загляните в раздел «Боты» и убедитесь, что ваши боты торгуют: ползунок на карточке должен быть включён.\n\n' +
      'Если что-то осталось сломанным — напишите в поддержку: @fund1ngsupport\n\n' +
      'Спасибо за терпение!',
    en:
      '🙏 Sorry for the temporary downtime\n\n' +
      'While we were doing maintenance, the app could be unstable: some sections did not open, and bots could stop responding to commands.\n\n' +
      'Everything is back to normal now. Please open the "Bots" section and make sure your bots are trading: the switch on the card should be on.\n\n' +
      'If something is still broken, contact support: @fund1ngsupport\n\n' +
      'Thank you for your patience!',
  },
  {
    id: 'maintenance-announce',
    group: 'Сбои и работы',
    title: 'Плановые работы — анонс',
    hint: 'Предупредить заранее, что приложение будет недоступно.',
    segment: 'all',
    parseMode: null,
    when: 'Отправлять ДО начала работ. После — обязательно отправьте «Работы завершены».',
    ru:
      '🛠 Плановые технические работы\n\n' +
      'Скоро я проведу технические работы на сервере. В это время приложение может быть временно недоступно: разделы могут не открываться или открываться с задержкой.\n\n' +
      'Что нужно сделать заранее: ничего. Ваши настройки, API-ключи и подписка остаются на месте.\n\n' +
      'Как только работы закончатся, я пришлю отдельное сообщение — и попрошу вас проверить ботов.',
    en:
      '🛠 Scheduled maintenance\n\n' +
      'I will be doing server maintenance soon. During that time the app may be temporarily unavailable: sections may not open or may load slowly.\n\n' +
      'Nothing to do in advance. Your settings, API keys and subscription stay as they are.\n\n' +
      'As soon as the maintenance is finished, I will send a separate message asking you to check your bots.',
  },
  {
    id: 'maintenance-done',
    group: 'Сбои и работы',
    title: 'Работы завершены, всё работает',
    hint: 'Закрыть анонс работ: приложение снова в строю, просьба проверить.',
    segment: 'all',
    parseMode: null,
    when: 'Отправлять сразу после окончания работ.',
    ru:
      '✅ Работы завершены — приложение снова работает\n\n' +
      'Сервер в строю, разделы открываются как обычно.\n\n' +
      'Пожалуйста, проверьте:\n' +
      '• раздел «Боты» — ползунок на карточке включён, бот торгует;\n' +
      '• баланс и открытые позиции отображаются;\n' +
      '• ваши API-ключи на месте (раздел «Биржи»).\n\n' +
      'Если что-то не так — напишите в поддержку: @fund1ngsupport',
    en:
      '✅ Maintenance is done — the app is working again\n\n' +
      'The server is back, all sections open as usual.\n\n' +
      'Please check:\n' +
      '• the "Bots" section — the switch on the card is on and the bot is trading;\n' +
      '• balance and open positions are displayed;\n' +
      '• your API keys are in place ("Exchanges" section).\n\n' +
      'If something is wrong, contact support: @fund1ngsupport',
  },

  // ───────────────────────── Нововведения ─────────────────────────
  {
    id: 'new-exchanges',
    group: 'Нововведения',
    title: 'Новые биржи: Binance и Bitget',
    hint: 'Новость про добавленные биржи — с упором «зайдите и подключите ключ».',
    segment: 'all',
    parseMode: 'HTML',
    when: 'Отправлять вместе с сообщением о работах: у части юзеров что-то могло не включиться.',
    ru:
      '🚀 <b>Новое: боты теперь работают ещё на двух биржах — Binance и Bitget</b>\n\n' +
      'Раньше боты торговали только на Bybit. Теперь к нему добавились Binance и Bitget.\n\n' +
      '<b>Как попробовать:</b>\n' +
      '1. Откройте раздел «Биржи».\n' +
      '2. Выберите Binance или Bitget и добавьте API-ключ с этой биржи.\n' +
      '3. Создайте нового бота и укажите в нём нужную биржу.\n\n' +
      'Ключ создаётся в личном кабинете биржи. Для торговли нужны права на фьючерсы; вывод средств по ключу лучше не разрешать.\n\n' +
      'Заодно я проводил технические работы — в этот момент приложение могло быть временно недоступно, приносим извинения. Если что-то не работает, напишите в поддержку: @fund1ngsupport',
    en:
      '🚀 <b>New: bots now work on two more exchanges — Binance and Bitget</b>\n\n' +
      'Previously bots traded on Bybit only. Now Binance and Bitget are available as well.\n\n' +
      '<b>How to try it:</b>\n' +
      '1. Open the "Exchanges" section.\n' +
      '2. Pick Binance or Bitget and add an API key from that exchange.\n' +
      '3. Create a new bot and choose the exchange in it.\n\n' +
      'You create the key in your exchange account. It needs futures trading permission; withdrawal permission is best left disabled.\n\n' +
      'I was also doing maintenance, so the app could be temporarily unavailable — sorry about that. If something is not working, contact support: @fund1ngsupport',
  },
  {
    id: 'new-feature',
    group: 'Нововведения',
    title: 'Новая функция — проверьте в приложении',
    hint: 'Универсальная заготовка под любую новую функцию: подставьте название и шаги.',
    segment: 'all',
    parseMode: null,
    when: 'Замените текст в скобках на реальное название и шаги перед отправкой.',
    ru:
      '✨ Новое в приложении: (название функции)\n\n' +
      'Коротко: (что это даёт юзеру — одной строкой).\n\n' +
      'Как попробовать:\n' +
      '1. Откройте раздел «(раздел)».\n' +
      '2. (шаг)\n' +
      '3. (шаг)\n\n' +
      'Проверьте, пожалуйста, новую функцию и напишите, если что-то непонятно или работает не так: @fund1ngsupport',
    en:
      '✨ New in the app: (feature name)\n\n' +
      'In short: (what it gives you — one line).\n\n' +
      'How to try it:\n' +
      '1. Open the "(section)" section.\n' +
      '2. (step)\n' +
      '3. (step)\n\n' +
      'Please give the new feature a try and let me know if anything is unclear or not working: @fund1ngsupport',
  },

  // ───────────────────── Проверка после работ ─────────────────────
  {
    id: 'check-bots',
    group: 'Проверка после работ',
    title: 'Проверьте, что боты торгуют',
    hint: 'Просьба заглянуть в ботов и убедиться, что они в работе.',
    segment: 'withbots',
    parseMode: null,
    when: 'Через несколько часов после работ — когда юзеры уже могли зайти, но ещё не проверили.',
    ru:
      '🤖 Проверьте, пожалуйста, ваших ботов\n\n' +
      'После технических работ прошу заглянуть в раздел «Боты» и убедиться, что всё в порядке:\n' +
      '• ползунок на карточке бота включён;\n' +
      '• бот показывает сделки, а не пустую историю;\n' +
      '• баланс на месте.\n\n' +
      'Если бот стоит без движения — выключите и включите его ползунком, он снова встанет в работу.\n\n' +
      'Не помогло? Напишите в поддержку: @fund1ngsupport',
    en:
      '🤖 Please check your bots\n\n' +
      'After the maintenance, please open the "Bots" section and make sure everything is fine:\n' +
      '• the switch on the bot card is on;\n' +
      '• the bot shows trades, not an empty history;\n' +
      '• your balance is in place.\n\n' +
      'If a bot is on but not trading, turn it off and on with the switch — it will get back to work.\n\n' +
      'Still not working? Contact support: @fund1ngsupport',
  },
  {
    id: 'check-keys',
    group: 'Проверка после работ',
    title: 'Проверьте API-ключи',
    hint: 'Для тех, у кого ключей нет: возможно, ключ не сохранился из-за недавней ошибки.',
    segment: 'nokeys',
    parseMode: null,
    when: 'Отправлять тем, у кого нет ключей — после исправления ошибки сохранения ключей.',
    ru:
      '🔑 API-ключи: проверьте, пожалуйста\n\n' +
      'Недавно в приложении исправляли работу с API-ключами — у некоторых пользователей ключ не сохранялся, и добавлять было просто нечего.\n\n' +
      'Если ключа у вас ещё нет:\n' +
      '1. Откройте раздел «Биржи».\n' +
      '2. Выберите свою биржу и добавьте ключ.\n' +
      '3. Проверьте, что у ключа разрешена торговля фьючерсами.\n\n' +
      'Напоминание: для приложения нужен ключ, созданный отдельно, а вывод средств по нему лучше отключить.\n\n' +
      'Если ключ не сохраняется — напишите в поддержку: @fund1ngsupport',
    en:
      '🔑 API keys: please check\n\n' +
      'We recently fixed the way API keys are saved — for some users a key would not save, so there was nothing to add.\n\n' +
      'If you do not have a key yet:\n' +
      '1. Open the "Exchanges" section.\n' +
      '2. Pick your exchange and add a key.\n' +
      '3. Make sure futures trading is allowed for that key.\n\n' +
      'Reminder: the app needs a key created separately, and withdrawal permission is best left disabled.\n\n' +
      'If the key does not save, contact support: @fund1ngsupport',
  },
  {
    id: 'support-invite',
    group: 'Проверка после работ',
    title: 'Что-то не работает — напишите в поддержку',
    hint: 'Финальное сообщение волны: просьба не молчать и писать в поддержку.',
    segment: 'all',
    parseMode: null,
    when: 'Отправлять последним в серии — когда основное уже починено.',
    ru:
      '🆘 Если что-то не работает — напишите нам\n\n' +
      'После обновления у части пользователей что-то могло не включиться. Не молчите, пожалуйста: мы отвечаем и помогаем.\n\n' +
      'Что полезно написать сразу:\n' +
      '• что именно не получается (открыть раздел, запустить бота, сохранить ключ);\n' +
      '• какой текст ошибки видно на экране;\n' +
      '• ваше имя в Telegram — чтобы мы нашли ваш аккаунт.\n\n' +
      'Написать: @fund1ngsupport',
    en:
      '🆘 If something is not working, message us\n\n' +
      'After the update something may not have started for some users. Please do not stay silent — we reply and help.\n\n' +
      'What is useful to send right away:\n' +
      '• what exactly fails (opening a section, starting a bot, saving a key);\n' +
      '• the error text you see on the screen;\n' +
      '• your Telegram name so we can find your account.\n\n' +
      'Message us: @fund1ngsupport',
  },
]

// Заготовки, сгруппированные для отрисовки: [{ group, items: [...] }].
// Порядок групп — как в BROADCAST_TEMPLATE_GROUPS, внутри — как в массиве выше.
export const BROADCAST_TEMPLATES_BY_GROUP = BROADCAST_TEMPLATE_GROUPS
  .map(group => ({ group, items: BROADCAST_TEMPLATES.filter(t => t.group === group) }))
  .filter(g => g.items.length)
